import { ContextProfileUser } from "../../lib/profileContext";
import { useContext, useState } from "react";
import {
  getBirthdayInFormat,
  getDate,
  getMonths,
  getYears,
  simplyClick,
  validateAge,
} from "../../helpers";
import SelectGlobal from "../SelectGlobal";
import ButtonGroup from "../ButtonGroup";
import { errorEventsBirthday } from "../../constants/index";
/**
 *Styles
 */
import "./Birthday.scss";

const Birthday = ({ setStep, step }) => {
  const { data, setData } = useContext(ContextProfileUser);
  const [errorBirthday, setErrorBirthday] = useState(null);

  const handlerSubmit = () => {
    const {
      status,
      error,
      errors = {},
    } = validateAge(data.month, data.day, data.year);

    const dateKey = [
      data.month ? "M" : "",
      data.day ? "D" : "",
      data.year ? "Y" : "",
    ].join("");

    if (!status && !dateKey) {
      setErrorBirthday(error);
      simplyClick("err_lnd_age_nodate");
      return;
    }

    // Only part of the date is entered
    if (errorEventsBirthday[dateKey]) {
      setErrorBirthday(error);
      simplyClick(errorEventsBirthday[dateKey]);
      return;
    }

    // No date is entered at all
    if (errors.invalidDate) {
      setErrorBirthday(error);
      return;
    }

    if (!status) {
      setErrorBirthday(error);
      return;
    }

    setErrorBirthday(null);

    setData({
      ...data,
      birthday: getBirthdayInFormat(data.year, data.month, data.day),
    });

    simplyClick("cl_lnd_qm3_step2_next");
    setStep(step + 1);
  };

  const handlerStepBack = () => {
    simplyClick("cl_lnd_qm3_step2_back");
    setStep(step - 1);
  };

  const handleAddMonth = (e) => {
    setErrorBirthday(null);
    setData({ ...data, month: e.target.value });
    simplyClick("cl_lnd_qm3_step2_month_choose");
  };

  const handleAddDay = (e) => {
    setErrorBirthday(null);
    setData({ ...data, day: e.target.value });
    simplyClick("cl_lnd_qm3_step2_day_choose");
  };

  const handleAddYear = (e) => {
    setErrorBirthday(null);
    setData({ ...data, year: e.target.value });
    simplyClick("cl_lnd_qm3_step2_year_choose");
  };

  return (
    <div className="global__form-wrap">
      <div className="birthday__form">
        <h5 className="form__title">Your date of birth is</h5>
        <div>
          <div className="date__wrapper">
            <SelectGlobal
              dateArray={getMonths()}
              data={data?.month}
              handleChange={handleAddMonth}
              label={"Month"}
              errorBirthday={errorBirthday}
            />
            <SelectGlobal
              dateArray={getDate()}
              data={data?.day}
              handleChange={handleAddDay}
              label={"Day"}
              errorBirthday={errorBirthday}
            />
            <SelectGlobal
              dateArray={getYears()}
              data={data?.year}
              handleChange={handleAddYear}
              customClass={"year"}
              label={"Year"}
              errorBirthday={errorBirthday}
            />
          </div>
          {errorBirthday && <p className="error-text">{errorBirthday}</p>}
        </div>

        <div className="global__text">
          By proceeding, you confirm you are at least 18 years old.
        </div>
      </div>
      <ButtonGroup cbStepNext={handlerSubmit} cbStepBack={handlerStepBack} />
    </div>
  );
};
export default Birthday;
